import React, {useEffect, useState} from 'react';
import {Select, Radio, Input} from 'antd';
import {FiUser, FiCalendar, FiTag, FiAlertCircle, FiSearch} from 'react-icons/fi';
import {priorities} from "@/components/taskManagement/PriorityDropdown";

const TaskFilterHeader = ({
                              users,
                              selectedUser,
                              filterType,
                              onFilterTypeChange,
                              onUserSelect,
                              dueFilter,
                              onDueFilterChange,
                              statuses,
                              selectedStatuses,
                              onStatusChange,
                              selectedPriorities,
                              onPriorityChange,
                              searchQuery,
                              onSearchChange
                          }) => {
    // Track open state of selects to close them on scroll
    const [openSelects, setOpenSelects] = useState({
        user: false,
        status: false,
        priority: false,
        dueDate: false
    });

    useEffect(() => {
        // Function to close all select dropdowns
        const handleScroll = () => {
            if (Object.values(openSelects).some(isOpen => isOpen)) {
                setOpenSelects({
                    user: false,
                    status: false,
                    priority: false,
                    dueDate: false
                });
            }
        };

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll, true);

        // Cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [openSelects]);

    const handleDropdownVisibilityChange = (dropdown, visible) => {
        setOpenSelects(prev => ({
            ...prev,
            [dropdown]: visible
        }));
    };

    return (
        <div className="bg-white mb-6 py-1 rounded-lg shadow-sm">
            <div className="flex items-center justify-between gap-6">
                <div className="flex flex-wrap items-center gap-6 flex-1">
                    <div>
                        <Radio.Group
                            value={filterType}
                            onChange={e => onFilterTypeChange(e.target.value)}
                            buttonStyle="solid"
                            className="mb-0"
                        >
                            <Radio.Button className="mb-0" value="my-tasks">My Tasks</Radio.Button>
                            <Radio.Button className="mb-0" value="all-tasks">All Tasks</Radio.Button>
                            <Radio.Button className="mb-0" value="by-user">By User</Radio.Button>
                        </Radio.Group>
                    </div>

                    {filterType === 'by-user' && (
                        <div className="flex items-center gap-2">
                            <FiUser className="text-gray-400"/>
                            <Select
                                placeholder="Select user"
                                style={{width: 200}}
                                value={selectedUser}
                                onChange={onUserSelect}
                                options={users.map(user => ({
                                    label: user.name,
                                    value: user.id,
                                    key: user.id
                                }))}
                                open={openSelects.user}
                                onDropdownVisibleChange={(visible) =>
                                    handleDropdownVisibilityChange('user', visible)
                                }
                            />
                        </div>
                    )}

                    <div className="flex items-center gap-2">
                        <FiTag className="text-gray-400"/>
                        <Select
                            mode="multiple"
                            style={{width: 200}}
                            placeholder="Filter by Status"
                            value={selectedStatuses}
                            onChange={onStatusChange}
                            maxTagCount="responsive"
                            allowClear
                            options={statuses.map(status => ({
                                label: (
                                    <div className="flex items-center gap-2">
                                        <div
                                            className="ml-2 w-2 h-2 rounded-full"
                                            style={{backgroundColor: status.color}}
                                        />
                                        <span>{status.name}</span>
                                    </div>
                                ),
                                value: status.id
                            }))}
                            open={openSelects.status}
                            onDropdownVisibleChange={(visible) =>
                                handleDropdownVisibilityChange('status', visible)
                            }
                        />
                    </div>

                    <div className="flex items-center gap-2">
                        <FiAlertCircle className="text-gray-400"/>
                        <Select
                            mode="multiple"
                            style={{width: 200}}
                            placeholder="Filter by Priority"
                            value={selectedPriorities}
                            onChange={onPriorityChange}
                            maxTagCount="responsive"
                            allowClear
                            options={priorities.map(priority => ({
                                label: (
                                    <div className="flex items-center gap-2">
                                        <div
                                            className="ml-2 w-2 h-2 rounded-full"
                                            style={{backgroundColor: priority.bgColor}}
                                        />
                                        <span>{priority.name}</span>
                                    </div>
                                ),
                                value: priority.id
                            }))}
                            open={openSelects.priority}
                            onDropdownVisibleChange={(visible) =>
                                handleDropdownVisibilityChange('priority', visible)
                            }
                        />
                    </div>

                    <div className="flex items-center gap-2">
                        <FiCalendar className="text-gray-400"/>
                        <Select
                            placeholder="Due Date Filter"
                            style={{width: 200}}
                            value={dueFilter}
                            onChange={onDueFilterChange}
                            allowClear
                            options={[
                                {label: 'All Tasks', value: 'all'},
                                {label: 'Due Today', value: 'today'},
                                {label: 'Due This Week', value: 'this-week'},
                                {label: 'Due Next Week', value: 'next-week'},
                                {label: 'Overdue', value: 'overdue'},
                                {label: 'No Due Date', value: 'no-date'}
                            ]}
                            open={openSelects.dueDate}
                            onDropdownVisibleChange={(visible) =>
                                handleDropdownVisibilityChange('dueDate', visible)
                            }
                        />
                    </div>
                </div>

                <div className="">
                    <Input
                        prefix={<FiSearch className="text-gray-400"/>}
                        placeholder="Search tasks"
                        value={searchQuery}
                        onChange={(e) => onSearchChange(e.target.value)}
                        allowClear
                        className="w-full"
                    />
                </div>
            </div>
        </div>
    );
};

export default TaskFilterHeader;
